import Banner from "./banner";
import Logo from "./logo";

export default function LogoHeader () {
    return (
        <div className="col-12 text-white">
            <div className='grid h-8rem'>
                <Logo />
                <Banner />
            </div>
        </div>
    )
}